module.exports = __webpack_public_path__ + "img/banner-certificados-m.2ab89da7.svg";